import React, { useState, useEffect } from "react";
import { Box, useTheme } from "@mui/material";

const sections = [
  { label: "PICTURES", id: "pictures" },
  { label: "VIDEO", id: "video" },
  { label: "AUDIO", id: "audio" },
  { label: "CREDITS", id: "credits" },
  { label: "SPECIALS SKILLS, TRAINING & BIO", id: "textSections" },
];

const TOP_OFFSET = 90;

export default function RightNav() {
  const theme = useTheme();
  const [active, setActive] = useState(sections[0].id);

  useEffect(() => {
    const update = () => {
      const scrollY = window.scrollY;
      let currentActive = sections[0].id;
      for (const s of sections) {
        const el = document.getElementById(s.id);
        if (!el) continue;
        const elTop = el.getBoundingClientRect().top + scrollY;
        if (scrollY >= elTop - TOP_OFFSET - 20) currentActive = s.id;
      }
      setActive(currentActive);
    };
    window.addEventListener("scroll", update, { passive: true });
    update();
    return () => window.removeEventListener("scroll", update);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    const top = el.getBoundingClientRect().top + window.scrollY - TOP_OFFSET;
    window.scrollTo({ top, behavior: "smooth" });
    setActive(id);
  };

  return (
    <Box
      component="nav"
      sx={{
        bgcolor: "#202020",
        color: "#fff",
        p: 0.5,
        borderRadius: "4px",
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", rowGap: 0.2 }}>
        {sections.map((s, index) => {
          const isActive = s.id === active;
          const isLast = index === sections.length - 1;
          return (
            <Box
              key={s.id}
              onClick={() => scrollTo(s.id)}
              sx={{
                cursor: "pointer",
                writingMode: "vertical-rl",
                textOrientation: "sideways",
                whiteSpace: "nowrap",
                py: 0.2,
                pl: 0.25,
                borderLeft: isActive ? `3px solid ${theme.palette.primary.main}` : "3px solid transparent",
                color: isActive ? theme.palette.primary.main : "inherit",
                "&:hover": { color: theme.palette.primary.dark },
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <span>{s.label}</span>
              {!isLast && <span style={{ opacity: 0.4 }}>/</span>}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}